import Vue from 'vue'
import Router from 'vue-router'
import Map from './views/Map.vue'
const Navigateweb = () => import('./views/NavigateWeb.vue')
const TripDetail = () => import('./views/TripDetail.vue')
const RwsTripDetail = () => import('./views/RwsTripDetail.vue')
const Image = () => import('./views/360Image.vue')
const PorscheNav = () => import('./views/porscheNav.vue')
const Shops = () => import('./views/Shops.vue')
const Around = () => import('./views/Around.vue')
const Maptest = () => import('./views/Maptest.vue')
const SiteDetail = () => import('./views/SiteDetail.vue')
const EventDetail = () => import('./views/EventDetail.vue')
const MallDetail = () => import('./views/MallDetail.vue')
const MerchantDetail = () => import('./views/MerchantDetail.vue')
const ShowDetail = () => import('./views/ShowDetail.vue')
const HotelDetail = () => import('./views/HotelDetail.vue')
const Album = () => import('./views/Album.vue')
const PlayGuide = () => import('./views/PlayGuide.vue')
const PromotionDetail = () => import('./views/PromotionDetail.vue')

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'map',
            component: Map,
            meta: {keepAlive: true}
        },
        {
            path: '/navigateweb',
            name: 'navigateweb',
            component: Navigateweb,
            meta: {keepAlive: false}
        },
        {
            path: '/tripDetail',
            name: 'tripDetail',
            component: TripDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/rwsTripDetail',
            name: 'rwsTripDetail',
            component: RwsTripDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/360Image',
            name: '360Image',
            component: Image,
            meta: {keepAlive: false}
        },
        {
            path: '/porscheNav/:data',
            name: 'porscheNav',
            component: PorscheNav,
            meta: {keepAlive: false}
        },
        {
            path: '/shops',
            name: 'shops',
            component: Shops,
            meta: {keepAlive: false}
        },
        {
            path: '/around',
            name: 'around',
            component: Around,
            meta: {keepAlive: false}
        },
        {
            path: '/maptest',
            name: 'maptest',
            component: Maptest,
            meta: {keepAlive: false}
        },
        {
            path: '/siteDetail/:id',
            name: 'siteDetail',
            component: SiteDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/eventDetail/:id',
            name: 'eventDetail',
            component: EventDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/mallDetail/:id',
            name: 'mallDetail',
            component: MallDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/merchantDetail/:id',
            name: 'merchantDetail',
            component: MerchantDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/showDetail/:id',
            name: 'showDetail',
            component: ShowDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/hotelDetail/:id',
            name: 'hotelDetail',
            component: HotelDetail,
            meta: {keepAlive: false}
        },
        {
            path: '/album',
            name: 'album',
            component: Album,
            meta: {keepAlive: false}
        },
        {
            path: '/playGuide',
            name: 'playGuide',
            component: PlayGuide,
            meta: {keepAlive: false}
        },
        {
            path: '/promotionDetail/:id',
            name: 'promotionDetail',
            component: PromotionDetail,
            meta: {keepAlive: false}
        }
    ]
})
